import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { KeyboardFocusModule } from '@spartacus/storefront';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { LaunchDialogService } from '../../../../core/modal';
import { UrlModule } from '../../../../core/routing';
import { CatalogArticleListModule, SpinnerModule } from '../../../../shared';
import { ModalModule } from '../../../../shared/components/modal';
import { PickerAttributeModule } from '../picker-attribute';
import { pdpListVariantsModalLayoutConfig } from './pdp-list-variants-modal-layout.config';
import { PdpListVariantsModalComponent } from './pdp-list-variants-modal.component';

@NgModule({
  declarations: [PdpListVariantsModalComponent],
  imports: [
    CommonModule,
    NzIconModule,
    I18nModule,
    UrlModule,
    SpinnerModule,
    RouterModule,
    PickerAttributeModule,
    CatalogArticleListModule,
    KeyboardFocusModule,
    ModalModule,
  ],
  exports: [PdpListVariantsModalComponent],
})
export class PdpListVariantsModalModule {
  constructor(private launchDialogService: LaunchDialogService) {
    this.launchDialogService.registerModalLayoutConfig(pdpListVariantsModalLayoutConfig);
  }
}
